import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
//import styles from '../../../styles';

const StyledFigure = styled.div`
  position: absolute !important;
  top: 1rem;
  right: 1rem;
  left: unset;
  width: 2rem;
  height: 0.5rem;
  .circular & {
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    right: auto;
  }
  display: flex;
  pointer-events: none;

  img {
    width: 100%;
    height: auto;
  }
`;

const ActivityIndicator = ({ className }) => {
  if (className === 'exited') {
    return null;
  }

  return (
    <StyledFigure className={className}>
      <img src={`${process.env.PUBLIC_URL}img/loader.gif`} alt="" />
    </StyledFigure>
  );
};

ActivityIndicator.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

/*
const activity = keyframes`
from {
  transform: scale(0.5);
}

to {
  transform: scale(1);
}
`;
const ActivityIndicator = styled(({ loading, ...rest }) => {
  return (
    <div {...rest}>
      <svg viewBox="0 0 32 8">
        <circle cx="4" cy="4" r="4" />
        <circle cx="16" cy="4" r="4" />
        <circle cx="28" cy="4" r="4" />
      </svg>
    </div>
  );
})`
  position: absolute;
  top: 1rem;
  right: 1rem;
  left: unset;
  width: auto;
  height: auto;
  //transform: translate3d(0,0,0);
  .circular & {
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    right: auto;
  }
  display: flex;
  //opacity: 1;
  //transition: opacity 0.5s ${styles.easing.inOutCubic};
  
  
  pointer-events: none;
  
  &.exited {
    display: none;
    svg {
      animation: none !important;
    }
  }

  &.fade-exit {
    opacity: 1;
  }
  
  &.fade-exit.fade-exit-active {
    opacity: 0;
    transition: opacity 0.5s ${styles.easing.inOutCubic};
  }
  
  svg {
    width: 2rem;
    height: 0.5rem;
    circle {
      fill: ${styles.color.SLATE_LIGHT};
      animation: ${activity} 0.45s infinite alternate;
      transform-origin: 50% 50%;

      &:nth-of-type(1) {
        animation-delay: 0s;
      }
      &:nth-of-type(2) {
        animation-delay: 0.15s;
      }
      &:nth-of-type(3) {
        animation-delay: 0.3s;
      }
    }
  }
`;
/*
const ActivityIndicatorOrbit = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  display: flex;
  width: 0.675rem;
  height: 0.675rem;
  border-radius: 100%;
  background: ${styles.color.SLATE_LIGHT};
  opacity: 1;
  transition: opacity 0.5s ${styles.easing.inOutCubic};
  ${props =>
    !props.loading &&
    `
    opacity: 0;
  `} &:after, &:before {
    content: '';
    position: absolute;
    width: 0.35rem;
    height: 0.35rem;
    border-radius: 100%;
  }

  &:after {
    left: -0.7rem;
    top: -0.35rem;
    opacity: 0.5;
    background: ${styles.color.SLATE_LIGHT};
    transform-origin: 1.05rem 0.7rem;
    animation: ${rotate} 1s linear infinite;
  }
  &:before {
    left: -1rem;
    top: -0.5rem;
    background: ${styles.color.SLATE_LIGHT};
    opacity: 0.35;
    transform-origin: 1.35rem 0.85rem;
    animation: ${rotate} 1.5s linear infinite;
  }
`;
*/

export default ActivityIndicator;



// WEBPACK FOOTER //
// ./src/modules/pages/components/ActivityIndicator.js